import { getIn } from 'seamless-immutable';
import { dispatchEvent, createPage, createProject, createNavigation, createContext } from '../helpers';

export const adsLoad = ({ routerProps, client, body }) => {
  try {
    const payload = createAdsLoadBody({ routerProps, client, body });
    if (payload) {
      dispatchEvent('ads:load', payload);
    }
  } catch (e) {}
};

const createAdsLoadBody = ({ routerProps, client, body }) => {
  const ads = createAds({ routerProps, client, body });
  if (ads.ads.length === 0) {
    return false;
  }

  return {
    page: createPage({ routerProps, client, body }),
    project: createProject({ routerProps, client, body }),
    navigation: createNavigation(),
    ads,
    context: createContext({ client }),
  };
};
const createAds = ({ routerProps, client, body }) => {
  const { template = {} } = body?.page;

  const ads = Object.keys(template)
    .reduce((prev, curr) => prev.concat(template[curr] || []), [])
    .filter(position => position.type === 'b2wads')
    .map(pos => ({
      ...getIn(body, ['page', 'components', pos.id]),
      type: pos.id,
    }))
    .filter(Boolean)
    .filter(shelf => shelf.products);

  return { ads, success: ads.length > 0, total: ads.length };
};
